import React from 'react';
import PropTypes from 'prop-types';

import {
  Text,
  TextWithTooltip,
  Icon,
  IconWithTooltip,
  TablePerson
} from 'components/common/Elements/Elements';

import classes from './SubCellBody.module.scss';

const SubCellBody = ({ data = [] }) => {
  const parsService = textForPars => {
    let parsText = textForPars.slice(1, -1);
    if (parsText !== '') {
      parsText = parsText.split('"').join('');
      parsText = parsText.split('}').join('');
      parsText = parsText.split('{').join('');
      parsText = parsText.split('],');
      parsText = parsText.map(item =>
        item[item.length - 1] !== ']' ? item + ']' : item
      );
    }
    return parsText.length !== 0 ? (
      <div className={classes.wrapTooltip}>
        {parsText.map(item => (
          <Text className={classes.tooltip} key={item} type="p">
            {item}
          </Text>
        ))}
      </div>
    ) : (
      <Text className={classes.tooltip}>-</Text>
    );
  };

  return (
    <div>
      {data.length === 0 ? (
        <Text className={classes.textWrap}>
          <Icon icon={'vnc'} className={classes.icon} size="16px" />
          Any
        </Text>
      ) : (
        data.map(item => (
          <Text className={classes.textWrap} key={item.endpointName}>
            {item.endpointType === 'group' ? (
              <>
                <Icon
                  icon={'groupNetwok'}
                  className={classes.icon}
                  size="20px"
                />
                <TextWithTooltip text={item.endpointName} />
              </>
            ) : item.endpointType === 'address' ? (
              <>
                <IconWithTooltip
                  icon="globe"
                  className={classes.icon}
                  text={item.objectIpAddress}
                  size="16px"
                />
                <TextWithTooltip text={item.endpointName} />
              </>
            ) : item.endpointType === 'service' ? (
              <>
                <IconWithTooltip
                  icon="sevices"
                  className={classes.icon}
                  text={parsService(item.objectProtocols)}
                  size="16px"
                />
                <TextWithTooltip text={item.endpointName} />
              </>
            ) : (
              item.endpointName !== ' ' && (
                <>
                  <div className={classes.avatar}>
                    <TablePerson person={item.endpointName} />
                  </div>

                  <TextWithTooltip text={item.endpointName} />
                </>
              )
            )}
          </Text>
        ))
      )}
    </div>
  );
};

SubCellBody.propTypes = {
  data: PropTypes.array
};

export default SubCellBody;
